<template>
  <div>
    <v-btn
      block
      class="info rounded-pill my-4"
      dark
      @click.stop="dialogForm = true"
      ><v-icon class="mr-4">mdi-tractor-variant</v-icon> Nouvelle
      Dotation</v-btn
    >
    <v-dialog
      v-model="dialogForm"
      fullscreen
      hide-overlay
      transition="slide-x-transition"
    >
      <v-card>
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <v-btn icon @click="dialogForm = false">
              <v-icon>mdi-arrow-left</v-icon> </v-btn
            >Nouvelle Dotation {{ projet }}
          </v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-container fluid>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="ll_dotation"
                    label="Libellé de la Dotation"
                    prepend-icon="person"
                    :rules="requis"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedDateDebutFormattedMomentjs"
                        label="Date de la Dotation"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="date_dotation"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="nombre_participants"
                    label="Nombre de participants"
                    prepend-icon="person"
                    :rules="requisNbrparticipants"
                    required
                    type="number"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="projet_selected"
                    ref="projet_selected"
                    @change="setActivite()"
                    dense
                    :items="user.projets"
                    label="Projets"
                    outlined
                    item-value="ll_programme"
                    item-text="ll_programme"
                    :rules="selectRules"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="activite_selected"
                    ref="activite_selected"
                    @change="selectActivite()"
                    dense
                    :items="activites"
                    label="Activités"
                    outlined
                    item-value="ll_parcours"
                    item-text="ll_parcours"
                    :rules="selectRules"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="district_selected"
                    ref="district_selected"
                    @change="setCommunes()"
                    dense
                    :items="user.districts"
                    label="Districts"
                    outlined
                    item-value="id_district"
                    item-text="ll_district"
                    :rules="selectRules"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="commune_selected"
                    ref="commune_selected"
                    @change="setFokontanys()"
                    dense
                    :items="communes"
                    label="Communes"
                    outlined
                    item-value="id"
                    item-text="ll_commune"
                    :rules="selectRules"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="fokontany_selected"
                    ref="fokontany_selected"
                    dense
                    @change="selectedFokontany()"
                    :items="fokontanys"
                    label="Fokontany"
                    outlined
                    item-value="id"
                    item-text="ll_fokontany"
                    :rules="selectRules"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-4 px-10">
          <v-btn class="rounded-pill neumorphic warning" @click="reset"
            >Annuler</v-btn
          >
          <v-btn
            class="rounded-pill neumorphic primary"
            :loading="newLoading"
            @click="create"
            >Enregistrer la dotation</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    projet: {
      type: String,
      required: true,
    },
  },
  created() {
    this.setActivite();
  },

  data() {
    return {
      bailleur_selected: "",
      projet_selected: this.projet,
      activite_selected: "",
      district_selected: "",
      commune_selected: "",
      fokontany_selected: "",
      projets: [],
      activites: [],
      communes: [],
      fokontanys: [],
      menu2: false,
      date_dotation: "",
      date_fin: "",
      newLoading: false,
      dialogForm: false,
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      requisNbrparticipants: [(v) => !!v || "Ce champ est obligatoire"],
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      ll_dotation: "",
      nombre_participants: "",
    };
  },
  methods: {
    create() {
      if (this.$refs.form.validate()) {
        let uuid = "0000aaaa-" + this.$uuid.v4();
        var self = this;
        this.newLoading = true;
        var newDotation = {
          fokontany_code_fokontany: this.fokontany_selected,
          date_dotation: this.date_dotation,
          nombre_participants: this.nombre_participants,
          ll_theme: this.$refs.activite_selected.selectedItems[0].ll_theme,
          ll_fdotation: this.ll_dotation,
          date_insert: this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          description_parcours: this.$refs.activite_selected.selectedItems[0]
            .description_parcours,
          themes_id_theme: this.$refs.activite_selected.selectedItems[0]
            .themes_id_theme,
          parcours_id_parcours: this.$refs.activite_selected.selectedItems[0]
            .id,
          ll_programme: this.projet_selected,
          users_id_user: this.user.uid,
          ll_parcours: this.activite_selected,
          abbr_parcours: this.$refs.activite_selected.selectedItems[0]
            .abbr_parcours,
          ll_bailleur: this.bailleur_selected,
          //programmes_id_programme: this.$refs.projet_selected.selectedItems[0]
          //  .id,
          //id_bailleur: this.$refs.bailleur_selected.selectedItems[0].id,
          //abbr_bailleur: this.$refs.bailleur_selected.selectedItems[0]
          //  .abbr_bailleur,
          id: uuid,
          nom_responsable: this.user.displayName,
          id_region: this.$refs.district_selected.selectedItems[0].id_region,
          id_district: this.district_selected,
          ll_district: this.$refs.district_selected.selectedItems[0]
            .ll_district,
          id_commune: this.commune_selected,
          ll_fokontany: this.$refs.fokontany_selected.selectedItems[0]
            .ll_fokontany,
          code_fokontany: this.fokontany_selected,
          ll_region: this.$refs.district_selected.selectedItems[0].ll_region,
          ll_commune: this.$refs.commune_selected.selectedItems[0].ll_commune,
        };

        //Dotations
        this.$firebase
          .firestore()
          .collection("dotations")
          .doc(uuid)
          .set(newDotation, { merge: true });
        console.log("Dotation créée id: " + uuid);
        //this.GetDotationsDeSuperviseur(this.user.uid);

        this.reset();
      } else {
        console.log("veuillez valider d'abord");
      }
    },
    reset() {
      this.$refs.form.reset();
      this.communes = [];
      this.newLoading = false;
      this.dialogForm = false;
    },
    setProjet() {
      let self = this;
      self.projets = [];

      this.$firebase
        .firestore()
        .collection("projets")
        .where("ll_bailleur", "==", this.bailleur_selected)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var projet = doc.data();
            projet.id = doc.id;

            self.projets.push({
              ...projet,
            });
          });
        });
    },
    setActivite() {
      let self = this;
      self.activites = [];
      console.log(this.projet_selected);
      this.$firebase
        .firestore()
        .collection("activites")
        .where("ll_programme", "==", this.projet_selected)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var activite = doc.data();
            activite.id = doc.id;
            self.activites.push({
              ...activite,
            });
          });
        });
    },

    selectActivite() {
      console.log(this.activite_selected);
    },
    setCommunes() {
      var self = this;
      this.communes = [];
      this.fokontanys = [];

      this.$firebase
        .firestore()
        .collection("communes")
        .where("id_district", "in", [
          this.district_selected.toString(),
          this.district_selected,
        ])
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var commune = doc.data();
            commune.id = doc.id;
            self.communes.push({
              ...commune,
            });
            self.communeLoading = false;
          });
        });
    },

    setFokontanys() {
      var self = this;

      this.fokontanys = [];
      this.$firebase
        .firestore()
        .collection("fokontanys")
        .where("id_commune", "in", [
          this.commune_selected.toString(),
          this.commune_selected,
        ])
        .get()
        .then(function (snap) {
          self.fokontanys = [];
          snap.forEach((doc) => {
            var fokontany = doc.data();
            //console.log(fokontany);
            fokontany.id = doc.id;
            self.fokontanys.push({
              ...fokontany,
            });
          });
        });
    },
    selectedFokontany() {
      console.log(this.fokontany_selected);
    },
    ...mapActions({
      GetActivites: "Activites/GetAll",
      GetDotationsDeSuperviseur: "Dotations/GetDotationsDeSuperviseur",
    }),
  },
  computed: {
    computedDateDebutFormattedMomentjs() {
      return this.date_dotation
        ? this.$moment(this.date_dotation).format("DD-MM-YYYY")
        : "";
    },
    ...mapState({
      bailleurs: (state) => state.Bailleurs.bailleurs,
      user: (state) => state.Auth.user,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
